import {Helperfn} from "General/global-js/helpers";

var DropdownHelper = function() {

  function bindEvents() {

    //close when blurring last tabbable element
    getTabbableChilds($dropdown).last().on("blur", hideDropdown);

    //shift tab
    $dropdowntoggle.on("keydown", function(e) {
      if (e.shiftKey && e.keyCode === 9) {
        hideDropdown();
      }
    });

    //Space
    $dropdowntoggle.on("keydown", function(e) {
      if (e.keyCode === 32) {
        e.preventDefault();
        toggleDropdown();
      }
    });

    //close when click outside
    $dropdowntoggle.on("click", function() {
      $body.on("mouseup", function(e) {
        handleOutsideClick(e);
      });
    });
  }

  function getTabbableChilds(node) {
    return node.find("button, [href], [tabindex]:not([tabindex=\"-1\"])");
  }

  function handleOutsideClick(e) {
    _opened = $dropdown.hasClass("show");
    $target = $(e.target);

    if (_opened === true && e.target.id != $dropdown.attr("id") && !$target.hasClasses(classList)) {
      hideDropdown();
      $body.off("mouseup", handleOutsideClick);
    }
  }

  function hideDropdown() {
    $dropdown.removeClass("show");
    $dropdowntoggle.attr("aria-expanded", "false");
  }

  function toggleDropdown() {
    if ($dropdown.hasClass("show")) {
      $dropdown.removeClass("show");
      $dropdowntoggle.attr("aria-expanded", "false");
    } else {
      $dropdown.addClass("show");
      $dropdowntoggle.attr("aria-expanded", "true");
    }
  }

  function init(dropdown, dropdowntoggle, outsideClickTargets) {
    $body = $("body");
    $dropdown = dropdown;
    $dropdowntoggle = dropdowntoggle;
    classList = outsideClickTargets;

    Helperfn.init();
    bindEvents();
  }

  var $body, $dropdown, $dropdowntoggle, $target, classList, _opened;

  return {
    init: init
  };

}();

export {DropdownHelper};
